export default "__VITE_ASSET__CFfQHsLR__"